import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faChartLine, faSitemap, faSearch } from '@fortawesome/free-solid-svg-icons';
import styles from './PredictiveSignals.module.css';
import AgenticChat from './AIMarketDecoder/FinaAgents/AgenticChat';
import Orchestrator from './AIMarketDecoder/FinaOrchestrator/Orchestrator';
import SmartSearchSuite from './SmartSearchSuite';

const options = [
  {
    key: 'fina-agent',
    icon: faRobot,
    accent: 'accentTeal',
    name: 'Data Analysis',
    desc: 'Analyze data, test relationships, and visualize results.',
  },
  {
    key: 'research-analyst',
    icon: faChartLine,
    accent: 'accentIndigo',
    name: 'Research Analyst',
    desc: 'Investigate complex questions with evidence, context, and synthesis.',
  },
  {
    key: 'fina-collective',
    icon: faSitemap,
    accent: 'accentPlum',
    name: 'Collective Intelligence',
    desc: 'Bring together multiple expert perspectives to surface stronger conclusions.',
  },
  {
    key: 'smart-search-suite',
    icon: faSearch,
    accent: 'accentAmber',
    name: 'Thematic Search',
    desc: 'Trace themes, trends, and opportunities across markets and entities.',
  },
];

const Discover = () => {
  const [active, setActive] = useState(null);
  const activeOption = options.find((item) => item.key === active);

  return (
    <div className={styles.page}>
      <div className={styles.breadcrumb}>
        <Link to="/" className={styles.breadcrumbLink}>Home</Link>
        <span className={styles.breadcrumbSep}>/</span>
        {activeOption ? (
          <button type="button" className={styles.breadcrumbLink} onClick={() => setActive(null)}>
            Discover
          </button>
        ) : (
          <span className={styles.breadcrumbCurrent}>Discover</span>
        )}
        {activeOption && (
          <>
            <span className={styles.breadcrumbSep}>/</span>
            <span className={styles.breadcrumbCurrent}>{activeOption.name}</span>
          </>
        )}
      </div>

      <div className={styles.panel}>
        {!activeOption ? (
          <>
            <p className={styles.eyebrow}>Discover</p>
            <h1 className={styles.headline}>Choose how you want to explore</h1>
            <p className={styles.subline}>
              Pick a path to start finding evidence, themes, and opportunities.
            </p>

            <div className={styles.optionGrid}>
              {options.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className={`${styles.optionCard} ${styles[item.accent]}`}
                  onClick={() => setActive(item.key)}
                >
                  <span className={styles.optionIcon}>
                    <FontAwesomeIcon icon={item.icon} />
                  </span>
                  <span className={styles.optionBody}>
                    <span className={styles.optionNameRow}>
                      <span className={styles.optionName}>{item.name}</span>
                      <span className={styles.optionArrow}>→</span>
                    </span>
                    <span className={styles.optionDesc}>{item.desc}</span>
                  </span>
                </button>
              ))}
            </div>
          </>
        ) : (
          <>
            <div className={styles.activeHeader}>
              <span className={styles.activeTitle}>{activeOption.name}</span>
              <div className={styles.tabStrip}>
                {options.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    title={item.desc}
                    className={`${styles.tab} ${styles[item.accent]} ${active === item.key ? styles.tabActive : ''}`}
                    onClick={() => setActive(item.key)}
                  >
                    <span className={styles.tabIcon}>
                      <FontAwesomeIcon icon={item.icon} />
                    </span>
                    {item.name}
                  </button>
                ))}
              </div>
            </div>

            <div className={styles.embedWrapper}>
              {active === 'fina-agent' && <AgenticChat fixedMode="numbers" />}
              {active === 'research-analyst' && <AgenticChat fixedMode="insights" />}
              {active === 'fina-collective' && <Orchestrator embedded />}
              {active === 'smart-search-suite' && <SmartSearchSuite />}
            </div>
          </>
        )}
      </div>

      <Link to="/" className={styles.backLink}>Back</Link>
    </div>
  );
};

export default Discover;
